import React, { useCallback } from "react";
import InputSection from "./InputsSection";
import ResultsSection from "./ResultsSection";
import { useAppDispatch, useAppSelector } from "../../store/hooks/hooks";
import PressureDropChart from "./PressureDropChart";
import "./PressureDrop.css";


const PressureDropCalculator: React.FC = () => {
	const dispatch = useAppDispatch();
	const calculator = useAppSelector(state => state.pressureDropCalculator);

	const handlePaste = useCallback(
		(event: React.ClipboardEvent<HTMLElement>) => {
			const clipboardText = event.clipboardData.getData("text");
			if (!clipboardText) {
				return;
			}

			const parsedValues = clipboardText
				.trim()
				.split(/\s+/)
				.map(token => Number.parseFloat(token.replace(",", ".")))
				.filter(value => Number.isFinite(value));

			if (parsedValues.length === 0) {
				return;
			}

			event.preventDefault();

			let startIndex = 0;
			const target = event.target;
			if (target instanceof HTMLInputElement) {
				const foundIndex = calculator.inputs.findIndex(
					input => input.id === target.id || input.queryName === target.name
				);
				if (foundIndex >= 0) {
					startIndex = foundIndex;
				}
			}

			// dispatch(insertValuesInARow({ values: parsedValues, startIndex }));
		},
		[dispatch, calculator]
	);

	return (
		<div className="pressure-drop__container" onPasteCapture={handlePaste} tabIndex={0}>
			<InputSection />
			<ResultsSection />
			<PressureDropChart />
		</div>
	)
}

export default PressureDropCalculator;
